import React, { forwardRef, Ref } from 'react';
import ReactDatePicker from 'react-datepicker';
import styled, { css } from 'styled-components';
import { colors } from '../../config/styles';
import { PositioningStrategy } from '@popperjs/core/lib/popper-lite';

interface IProps {
  selectedValue: Date;
  onChange: (date: Date | null) => void;
  dateFormat?: string;
  placeholderText?: string;
  autoFocus?: boolean;
  hasError?: boolean;
  positionStrategy?: PositioningStrategy;
}

const Wrapper = styled.div<{ $hasError?: boolean }>`
  ${({ $hasError }) =>
    $hasError &&
    css`
      .react-datepicker__input-container input {
        border-color: ${colors.mainError};
      }
    `}
`;

export default forwardRef(
  (
    {
      selectedValue,
      placeholderText = 'Year',
      dateFormat = 'yyyy',
      onChange,
      autoFocus,
      hasError,
      positionStrategy,
    }: IProps,
    ref: Ref<ReactDatePicker>,
  ) => {
    return (
      <Wrapper $hasError={hasError}>
        <ReactDatePicker
          ref={ref}
          placeholderText={placeholderText}
          selected={selectedValue}
          onChange={onChange}
          dateFormat={dateFormat}
          showYearPicker
          strictParsing
          disabledKeyboardNavigation
          useWeekdaysShort
          autoFocus={autoFocus}
          popperPlacement={'bottom-start'}
          showPopperArrow={false}
          popperProps={{
            strategy: positionStrategy || 'fixed',
          }}
          popperModifiers={[
            {
              name: 'preventOverflow',
              enabled: false,
            },
          ]}
        />
      </Wrapper>
    );
  },
);
